import { c as _c } from "react/compiler-runtime";
import { useState } from "react";
import Image from "../image/image";
interface ISelectProps {
  options: {
    label: string;
    value: string;
  }[];
  value: string;
  onChange: (value: string) => void;
}
const CustomSelect = t0 => {
  const $ = _c(18);
  const {
    options,
    value,
    onChange
  } = t0;
  const [open, setOpen] = useState(false);
  let t1;
  if ($[0] !== open) {
    t1 = () => setOpen(!open);
    $[0] = open;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== options || $[3] !== value) {
    t2 = options.find(opt => opt.value === value)?.label || "Select...";
    $[2] = options;
    $[3] = value;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const t3 = `transition-transform ${open ? "rotate-180" : ""} h-fit`;
  let t4;
  if ($[5] !== t3) {
    t4 = <Image src="/caret-down-mobile.svg" alt="Dropdown Icon" width={24} className={t3} />;
    $[5] = t3;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== t1 || $[8] !== t2 || $[9] !== t4) {
    t5 = <button type="button" onClick={t1} className="flex w-full justify-between rounded-md border border-[#4A4A4A] px-4 py-3 text-left text-[18px] leading-[135%] text-[#4A4A4A]">{t2}{t4}</button>;
    $[7] = t1;
    $[8] = t2;
    $[9] = t4;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== onChange || $[12] !== open || $[13] !== options) {
    t6 = open && <ul className="absolute left-0 right-0 top-full z-[999] mt-1 max-h-60 touch-auto overflow-auto rounded-md border border-gray-300 bg-white shadow-lg">{options.map(opt_0 => <li key={opt_0.value} onClick={() => {
        onChange(opt_0.value);
        setOpen(false);
      }} className="cursor-pointer px-4 py-2 hover:bg-gray-100">{opt_0.label}</li>)}</ul>;
    $[11] = onChange;
    $[12] = open;
    $[13] = options;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  let t7;
  if ($[15] !== t5 || $[16] !== t6) {
    t7 = <div className="pointer-events-auto relative w-full">{t5}{t6}</div>;
    $[15] = t5;
    $[16] = t6;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  return t7;
};
export default CustomSelect;